



















































import { Component, Watch } from 'vue-property-decorator';
import Form from '@/components/form-base';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import {pick} from 'lodash';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'
import api, { ReferalApi } from '@/views/settings/referral-program/api';

  @Component({
    components: {
      FormOverlay,
      DialogForm,
      HeaderButtons
    }
  })
  export default class EnableDialog extends Form {
    api: ReferalApi = api;


    loading: boolean = false;
    show_password: boolean = false;

    form: any = {};

    mounted() {
      this.fillForm(this.$store.state.user);
    }

    close() {
      this.$emit('close');
    }

    submit(){
      return this.api.put(this.form).then((res: any) => {
        this.$store.commit('updateUser', res);
        this.close()
        this.bus.emit('toast-success', this.t('Payment Details have been changed'));
      });
    }

    fillForm(source: any) {
      this.form = {
        ...this.form,
        ...pick(source, [
          'referralPaymentAccountType',
          'referralPaymentAccount'
        ])
      };
    }

    @Watch('$store.state.user')
    dataReceived(val: any) {
      this.fillForm(val);
    }

  }
